import TeamsPageNameCell from 'pages/Teams/Cells/NameCell';
import {
  hasNoPlatformAccounts,
  noPlatformAccountsReason,
} from 'pages/Teams/Cells/NameCell/noPlatformAccounts';
import type { ManagedTeamsType } from '../..';

interface CellProps {
  rowData: ManagedTeamsType;
}

export default function TeamNameCell({ rowData }: CellProps) {
  const hasNoAccounts = hasNoPlatformAccounts(rowData.platformAccounts);

  return (
    <TeamsPageNameCell
      hideLogo
      rowData={rowData}
      openInNewTab
      disabled={hasNoAccounts}
      disabledReason={hasNoAccounts ? noPlatformAccountsReason() : undefined}
    />
  );
}
